import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { Box, Typography } from 'app/shared/components/atoms';
import { useEventPageContext } from 'app/fan/context/EventPage';

const intlPrefix = 'event.eventCharacteristicsList.eventDetails';

export const EventDetailsSectionDetails = () => {
  const { formatMessage } = useIntl();
  const { colors } = useCurrentTheme();
  const { event } = useEventPageContext();

  return (
    <Box gap={3} flexDirection="column">
      <Box as="p" m={0}>
        <Typography
          as="span"
          display="inline"
          fontWeight="medium"
          fontSize="fontSize100"
          color={colors.primary.white.base}
        >
          {formatMessage({ id: `${intlPrefix}.duration` })}
        </Typography>
        <Typography
          as="span"
          display="inline"
          color={colors.primary.white.base}
        >
          {event &&
          (Number(event?.id) == 59071 || Number(event?.id) == 59008) ? (
            <>2 hours</>
          ) : (
            <> {formatMessage({ id: `${intlPrefix}.upTo3Hours` })}</>
          )}
        </Typography>
      </Box>
      <Box as="p" m={0}>
        <Typography
          as="span"
          display="inline"
          fontWeight="medium"
          fontSize="fontSize100"
          color={colors.primary.white.base}
        >
          {formatMessage({ id: `${intlPrefix}.addressReveal` })}
        </Typography>
        <Typography
          as="span"
          display="inline"
          color={colors.primary.white.base}
        >
          {formatMessage({ id: `${intlPrefix}.youWillReceive` })}
        </Typography>
      </Box>
    </Box>
  );
};
